import { $color_grey_10 } from '../pebbleGlobalToken/color.js';

/**
 * 导航菜单-padding间距
 * @description enDesc: -
 * @description type: Space
 * @description value: 24
 */
var $menu_padding = 24;

/**
 * 导航菜单-很大的padding间距
 * @description enDesc: -
 * @description type: Space
 * @description value: 48
 */
var $menu_padding_xl = 48;

/**
 * 导航菜单-每一项的radius
 * @description enDesc: -
 * @description type: Space
 * @description value: 0
 */
var $menu_radius_item = 0;

/**
 * 导航菜单-每一项的线条 margin
 * @description enDesc: -
 * @description type: Space
 * @description value: 0
 */
var $menu_item_margin_inline = 0;

/**
 * 导航菜单-info类型下的文本active状态的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-10
 */
var $menu_color_info_text_active = $color_grey_10;

export { $menu_color_info_text_active, $menu_item_margin_inline, $menu_padding, $menu_padding_xl, $menu_radius_item };
